module.exports = new __parcel__URL__("Fix top left.28e39702.svg").toString();